import { useLingui } from "@lingui/react";
import { createFileRoute, Outlet, redirect, useRouter } from "@tanstack/react-router";

import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

import { getDashboardSidebarServerFn, setDashboardSidebarServerFn } from "../dashboard/-components/functions";
import { DashboardSidebar } from "../dashboard/-components/sidebar";
import { getOperatorRouteAccessServerFn } from "./-components/functions";
import { operatorMessage } from "./-components/operator-i18n";

export const Route = createFileRoute("/operator")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (!context.session) {
      throw redirect({ to: "/auth/login", replace: true });
    }

    const decision = await getOperatorRouteAccessServerFn();

    if (!decision.allowed) {
      throw redirect({ to: "/dashboard", replace: true });
    }

    return { access: decision.access };
  },
  loader: async () => ({ sidebarState: await getDashboardSidebarServerFn() }),
});

function RouteComponent() {
  const { i18n } = useLingui();
  const router = useRouter();
  const { access } = Route.useRouteContext();
  const { sidebarState } = Route.useLoaderData();

  return (
    <SidebarProvider
      open={sidebarState}
      onOpenChange={async (open) => {
        await setDashboardSidebarServerFn({ data: open });
        void router.invalidate();
      }}
    >
      <DashboardSidebar operatorAccess={access} />
      <main className="@container flex-1 overflow-x-hidden p-4 md:ps-2" data-testid="dashboard-shell">
        <SidebarTrigger className="mb-2 md:hidden" aria-label={i18n._(operatorMessage("Mobile operator navigation"))} />
        <Outlet />
      </main>
    </SidebarProvider>
  );
}
